import React, { Component } from 'react';
import '../assets/css/bootstrap.min.css';
import '../assets/css/style.css';
import { Link } from 'react-router-dom';
import profilePic from '../assets/images/user-profile/profile-picture.png';
import instaIcon from '../assets/images/account-info/instagram.png';
import facebookIcon from '../assets/images/account-info/facebook.png';
import card1 from '../assets/images/user-profile/artwork-card-1.png';
import card2 from '../assets/images/user-profile/artwork-card-2.png';
import Header from './Header';

class UserProfileBuyer extends Component {
    render() {
        return (
            <div className="main-wrapper">
                {/* Header area start */}
                <Header />
                {/* Header area end */}

                {/* Userprofile area start */}
                <div className="container mb-5">
                    <div className="row justify-content-center user-area">
                        <div className="text-center">
                            <img src={profilePic} alt="" />
                            <h1>User Name</h1>
                            <small>@user handle</small>
                            <div>
                                <Link to="#"><img className="social-icon" src={instaIcon} alt="Instagram" /></Link>
                                <Link to="#"><img className="social-icon" src={facebookIcon} alt="Facebook" /></Link>
                            </div>
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p>
                        </div>
                        <div className="text-center curated">
                            <h2>Curated</h2>
                            <h6>2 NFTS owned by @userhandle on Lorem</h6>
                        </div>
                    </div>
                    <div className="row justify-content-center user-card">
                        <div className="card mt-4">
                            <img src={card1} className="card-img-top" alt="" />
                            <div className="card-body">
                                <h3>Artwork Title</h3>
                                <span><strong>$ 60,000.00</strong>&emsp;<small>6 OF 26</small></span>
                                <p className="card-text"><span><small>HIGHEST BID</small>&emsp;<strong>$49,000.00</strong></span></p>
                            </div>
                        </div>
                        <div className="card mt-4">
                            <img src={card2} className="card-img-top" alt="" />
                            <div className="card-body">
                                <h3>Artwork Title</h3>
                                <span><strong>Not for sale</strong>&emsp;<small>7 OF 26</small></span>
                                <p className="card-text"><span><small>LAST SOLD</small>&emsp;<strong>$13,000.00</strong></span></p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Userprofile area end */}
            </div>
        )
    }
};

export default UserProfileBuyer;